import { makeStyles } from "@material-ui/core";

export const useEditProfileModalStyles = makeStyles((theme) => ({
  hiddenInput: {
    display: "none",
  },

  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.4)",
    zIndex: 1300,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
  },

  modal: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "584px",
    maxHeight: "92vh",
    display: "flex",
    padding:"24px 32px",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "90%",
      padding: "20px 16px",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 0",
    flexShrink: 0,
  },

  title: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 700,
    fontSize: "24px",
    color: "#3D3D3D",
    lineHeight: 1.4,
  },

  closeBtn: {
    cursor: "pointer",
    width: "28px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#F5F5F5",
    fontSize: "16px",
    lineHeight: 1.4,
    color: "#666",
    border: "none",
    padding: 0,
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
  },

  scrollBody: {
    overflowY: "auto",
    scrollbarWidth: "thin",
    scrollbarColor: "#E0E0E0 transparent",
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  mediaRow: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    marginBottom: "20px",
  },

  mediaItem: {
    position: "relative",
    flexShrink: 0,
  },

  profilePic: {
    width: "128px",
    height: "128px",
    objectFit: "contain",
    display: "block",
    borderRadius: "10px",
    [theme.breakpoints.down("xs")]: {
      width: "80px",
      height: "80px",
    },
  },

  profilePicBorder: {
    border: "2px solid #FFD461",
    borderRadius: "12px",
    overflow: "hidden",
    display: "inline-flex",
  },

  profilePicPlaceholder: {
    width: "128px",
    height: "128px",
    borderRadius: "50%",
    backgroundColor: "#F5F5F5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    color: "#BDBDBD",
    border: "2px solid #FFD461",
  },

  videoThumb: {
    width: "227px",
    height: "128px",
    borderRadius: "12px",
    objectFit: "contain",
    border: "2px solid #F0F0F0",
    display: "block",
    backgroundColor: "#000",
    [theme.breakpoints.down("xs")]: {
      width: "142px",
      height: "auto",
    },
  },

  profilePicPlaceholderImg: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
  },

  videoPlaceholder: {
    width: "227px",
    height: "128px",
    borderRadius: "12px",
    backgroundColor: "#F5F5F5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    lineHeight: 1.4,
    color: "#BDBDBD",
    textAlign: "center",
    padding: "8px",
    cursor: "pointer",
  },

  editOverlay: {
    position: "absolute",
    bottom: 8,
    right: 8,
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#3377FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& svg": {
      width: "12px",
      height: "12px",
      fill: "#fff",
    },
  },

  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginBottom: "20px",
    "&:last-child": {
      marginBottom: 10,
    },
  },

  label: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#3D3D3D",
    "& span": {
      color: "#E53935",
    },
  },

  input: {
    width: "100%",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    padding: "10px 14px",
    fontSize: "16px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: "-0.04em",
    color: "#3D3D3D",
    outline: "none",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    "&::placeholder": {
      color: "#999999",
    },
    "&:disabled": {
      backgroundColor: "#f0f0f0",
    },
  },

  textarea: {
    width: "100%",
    border: "1px solid #E0E0E0",
    borderRadius: "4px",
    padding: "10px 14px",
    fontSize: "16px",
    fontFamily: "'Inter', sans-serif",
    fontWeight: 500,
    lineHeight: 1.4,
    letterSpacing: "-0.04em",
    color: "#3D3D3D",
    outline: "none",
    resize: "none",
    minHeight: "80px",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    "&::placeholder": {
      color: "#999999",
    },
  },

  inputError: {
    border: "1px solid #E53935 !important",
  },

  phoneInputWrapper: {
    "& .react-tel-input .form-control": {
      width: "100%",
      height: "auto",
      border: "1px solid #E0E0E0",
      borderRadius: "4px",
      padding: "10px 14px 10px 52px",
      fontSize: "16px",
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      lineHeight: 1.4,
      color: "#3D3D3D",
      outline: "none",
      boxSizing: "border-box",
    },
    "& .react-tel-input .form-control:focus": {
      outline: "none",
      boxShadow: "none",
      border: "1px solid #E0E0E0",
    },
    "& .react-tel-input .flag-dropdown": {
      borderRadius: "4px 0 0 4px",
      // border: "1px solid #E0E0E0",
      backgroundColor: "#FAFAFA",
    },
    "& .react-tel-input .selected-flag:hover, & .react-tel-input .selected-flag:focus": {
      backgroundColor: "#F0F0F0",
    },
    "& .react-tel-input .country-list": {
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
    },
  },

  phoneInputError: {
    "& .react-tel-input .form-control": {
      border: "1px solid #E53935",
    },
    "& .react-tel-input .flag-dropdown": {
      border: "1px solid #E53935",
    },
  },

  textareaError: {
    border: "1px solid #E53935 !important",
  },

  selectWrapperError: {
    border: "1px solid #E53935",
  },

  errorText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: 1.4,
    color: "#E53935",
    marginTop: "2px",
  },

  selectWrapper: {
    border: "1px solid #E0E0E0",
    borderRadius: "8px",
    width: "100%",
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& > div": {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      width: "100%",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-root": {
      padding: "10px 14px",
      fontSize: "16px",
      fontFamily: "'Inter', sans-serif",
      fontWeight: 500,
      lineHeight: "24px",
      letterSpacing: "-0.04em",
      color: "#3D3D3D",
    },
    "& .MuiSelect-select": {
      backgroundColor: "transparent",
    },
  },

  footer: {
    padding: "16px 20px 0 20px",
    borderTop: "1px solid #F0F0F0",
    flexShrink: 0,
  },

  saveBtn: {
    margin: "0 auto",
    width: "65%",
    padding: "14px",
    backgroundColor: "#FF712D",
    boxShadow: "0px 2px 4px 0px #00000014",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    lineHeight: 1.4,
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },

  spinner: {
    width: "18px",
    height: "18px",
    border: "2px solid rgba(255,255,255,0.4)",
    borderTop: "2px solid #fff",
    borderRadius: "50%",
    animation: "$spin 0.8s linear infinite",
  },

  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
}));
